<template>
  <div class="wg-col wg-xs-12" style="padding:2%;">
    <wg-modal
      v-if="openModal"
      :width="windowWidth > 700 ? '500px' : '80%'"
      :portal="true"
      @closeModal="closeModal"
      :confirmOnClose="true"
      :confirmOnCloseMsg="
        $anm22.strLang(lang, 'Discard changes?', 'Scartare le modifiche?')
      "
    >
      <div slot="header">
        <span>{{
          mode == "edit"
            ? $anm22.strLang(
                lang,
                "Edit " + currentModel.modelName + " Sz. " + currentModel.size,
                "Modifica " +
                  currentModel.modelName +
                  " Tg. " +
                  currentModel.size
              )
            : $anm22.strLang(lang, "New", "Nuovo")
        }}</span>
      </div>

      <div slot="body">
        <span>{{ $anm22.strLang(lang, "Model name", "Nome modello") }}</span>
        <div class="wg-col wg-xs-5">
          <input
            class="input-elem print-elem com-anm22-app-input-text"
            type="text"
            v-model="currentModel.modelName"
            :disabled="currentModelType != 'model'"
          />
          <div class="vertical-height-div" style="height:12px;"></div>
        </div>
        <template v-if="currentModelType == 'size'">
          <span>{{ $anm22.strLang(lang, "Size", "Taglia") }}</span>
          <div class="wg-col wg-xs-5">
            <input
              class="input-elem print-elem com-anm22-app-input-text"
              type="text"
              v-model="currentModel.size"
            />
            <div class="vertical-height-div" style="height:12px;"></div>
          </div>
        </template>
        <template v-if="currentModelType == 'model'">
          <span>{{ $anm22.strLang(lang, "Fit", "Vestibilità") }}</span>
          <div class="vertical-height-div" style="height:12px;"></div>
          <div class="wg-row">
            <div class="wg-row input-row measure">
              <div class="wg-col wg-xs-1">
                <div class="com-anm22-app-text-m"></div>
              </div>
              <div class="wg-col wg-xs-5">
                <div class="input-text com-anm22-app-text-m"></div>
              </div>
              <div class="wg-col wg-xs-2">Racing</div>
              <div class="wg-col wg-xs-2">Sport</div>
              <div class="wg-col wg-xs-2">Roomy</div>
            </div>
            <div
              class="wg-row input-row measure"
              v-for="(input, index) in fields"
              :key="'input' + index"
            >
              <div class="wg-col wg-xs-1">
                <div class="com-anm22-app-text-m">{{ index + 1 }}</div>
              </div>
              <div class="wg-col wg-xs-5">
                <div class="input-text com-anm22-app-text-m">
                  {{ input.label }}
                </div>
              </div>
              <div class="wg-col wg-xs-2">
                <input
                  class="input-elem print-elem com-anm22-app-input-text"
                  type="text"
                  v-model="currentModel.fits.racing[input.name]"
                />
              </div>
              <div class="wg-col wg-xs-2">
                <input
                  class="input-elem print-elem com-anm22-app-input-text"
                  type="text"
                  v-model="currentModel.fits.sport[input.name]"
                />
              </div>
              <div class="wg-col wg-xs-2">
                <input
                  class="input-elem print-elem com-anm22-app-input-text"
                  type="text"
                  v-model="currentModel.fits.roomy[input.name]"
                />
              </div>
            </div>
            <div class="vertical-height-div" style="height:20px;"></div>
            <div class="wg-row">
              <input
                type="button"
                :value="$anm22.strLang(lang, 'Save', 'Salva')"
                @click="addModel"
              />
            </div>
          </div>
        </template>
        <template v-if="currentModelType == 'size'">
          <span>{{ $anm22.strLang(lang, "Measures", "Misure") }}</span>
          <div class="vertical-height-div" style="height:12px;"></div>
          <div class="wg-row">
            <div
              class="wg-row input-row measure"
              v-for="(input, index) in fields"
              :key="'input' + index"
            >
              <div class="wg-col wg-xs-1">
                <div class="com-anm22-app-text-m">{{ index + 1 }}</div>
              </div>
              <div class="wg-col wg-xs-5">
                <div class="input-text com-anm22-app-text-m">
                  {{ input.label }}
                </div>
              </div>
              <div class="wg-col wg-xs-2">
                <input
                  class="input-elem print-elem com-anm22-app-input-text"
                  type="text"
                  v-model="currentModel.modelSizes[input.name]"
                />
              </div>
            </div>
            <div class="vertical-height-div" style="height:20px;"></div>
            <div class="wg-row">
              <input
                type="button"
                :value="$anm22.strLang(lang, 'Save', 'Salva')"
                @click="addModel"
              />
            </div>
          </div>
        </template>
      </div>
    </wg-modal>
    <div style="font-size:24px;" class="com-anm22-app-text-m">
      {{ $anm22.strLang(lang, "Models", "Modelli") }}
    </div>
    <div class="vertical-height-div" style="height:20px;"></div>
    <div
      v-for="(model, index) in orderedModels"
      :key="index"
      style="margin-bottom:12px"
    >
      <div class="wg-row" style="margin-bottom:6px">
        <span style="padding:11px;">{{ model.modelName }}</span>
        <input
          type="button"
          :value="$anm22.strLang(lang, 'Edit', 'Modifica')"
          @click="selectModel(model, 'model')"
        />
        <div class="com-anm22-horizontal-div" style="width: 10px;"></div>
        <input
          type="button"
          :value="$anm22.strLang(lang, 'Delete', 'Elimina')"
          @click="removeModel(model)"
        />
      </div>
      <div
        class="wg-row"
        style="padding-left: 20px; margin-bottom: 6px;"
        v-for="(size, index) in getModelSizes(model.modelName)"
        :key="index"
      >
        <span style="padding:11px;"
          >{{ $anm22.strLang(lang, "Sz.", "Tg.") }} {{ size.size }}</span
        >
        <input
          type="button"
          :value="$anm22.strLang(lang, 'Edit', 'Modifica')"
          @click="selectModel(size, 'size')"
        />
        <div class="com-anm22-horizontal-div" style="width: 10px;"></div>
        <input
          type="button"
          :value="$anm22.strLang(lang, 'Delete', 'Elimina')"
          @click="removeModel(size)"
        />
      </div>
      <div class="wg-row" style="padding-left:30px">
        <input
          type="button"
          :value="$anm22.strLang(lang, 'Add size', 'Aggiungi taglia')"
          @click="initNewSize(model)"
        />
      </div>
    </div>
    <div class="vertical-height-div" style="height:20px;"></div>
    <div class="wg-row">
      <input
        type="button"
        :value="$anm22.strLang(lang, 'Add model', 'Aggiungi modello')"
        @click="initNewModel"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      models: [],
      mode: "edit",
      openModal: false,
      currentModel: null,
      currentModelType: null,
      fields: [
        {
          name: "punto-spalla",
          label: "Punto spalle",
        },
        {
          name: "circ-torace",
          label: "Circonferenza torace",
        },
        {
          name: "circ-vita",
          label: "Circonferenza vita",
        },
        {
          name: "circ-bacino",
          label: "Circonferenza bacino",
        },
        {
          name: "da-pv-a-ginocchio",
          label: "Da punto vita a centro ginocchio",
        },
        {
          name: "da-pv-a-caviglia",
          label: "Da punto vita a caviglia",
        },
        {
          name: "da-pv-a-terra",
          label: "Da punto vita a terra",
        },
        {
          name: "manica-spalla-gomito",
          label: "Lunghezza manica da spalla a centro gomito",
        },
        {
          name: "manica-gomito-fondo",
          label: "Lunghezza manica da centro gomito a fondo",
        },
        {
          name: "circ-braccio",
          label: "Circonferenza braccio",
        },
        {
          name: "circ-avanbraccio",
          label: "Circonferenza avanbraccio",
        },
        {
          name: "circ-polso",
          label: "Circonferenza polso",
        },
        {
          name: "circ-coscia",
          label: "Circonferenza coscia",
        },
        {
          name: "circ-ginocchio",
          label: "Circonferenza ginocchio",
        },
        {
          name: "circ-polpaccio",
          label: "Circonferenza polpaccio",
        },
        {
          name: "circ-caviglia",
          label: "Circonferenza caviglia",
        },
        {
          name: "lung-vita",
          label: "Lunghezza vita",
        },
        {
          name: "altezza",
          label: "Altezza cm",
        },
        {
          name: "peso",
          label: "Peso kg",
        },
        {
          name: "manica-piegata-totale",
          label: "10+9 lunghezza manica piegata totale",
        },
        {
          name: "ovetto",
          label: "Ovetto",
        },
        {
          name: "punto-seno",
          label: "Punto seno (donna)",
        },
        {
          name: "dist-seni",
          label: "Distanza seni (donna)",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      windowWidth: (state) => state.windowWidth,
    }),
    orderedModels() {
      return this.models
        .filter((item) => !item.size)
        .sort((a, b) => {
          const modelCompare = a.modelName.localeCompare(b.modelName);
          if (modelCompare !== 0) {
            return modelCompare;
          }
          return 0;
        });
    },
  },
  methods: {
    loadData() {
      return this.$vlf("vircos-models-base")
        .getItems()
        .then((result) => {
          if (result) {
            this.models = Object.values(result);
          }
        });
    },
    initNewModel() {
      this.currentModelType = "model";
      this.currentModel = {};
      this.currentModel.modelSizes = null;
      this.currentModel.fits = {
        racing: {},
        sport: {},
        roomy: {},
      };
      this.mode = "new";
      this.openModal = true;
    },
    initNewSize(model) {
      this.currentModelType = "size";
      this.currentModel = {};
      this.currentModel.modelName = model.modelName;
      this.currentModel.modelSizes = {};
      this.currentModel.fits = null;
      this.mode = "new";
      this.openModal = true;
    },
    addModel() {
      this.$http
        .post(
          "vircos/add",
          {
            mode: this.mode,
            model: this.currentModel,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.$vlf("vircos-models-base").setItem(
            String(response.data.model.idVircosModelsBase),
            response.data.model
          );
          this.loadData();
          this.$anm22.eventBus.$emit("wg-modal-close");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    removeModel(model) {
      this.$http
        .post(
          "vircos/remove",
          {
            model: model,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.$vlf("vircos-models-base")
            .removeItem(String(model.idVircosModelsBase))
            .then((result) => {
              this.loadData();
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    selectModel(model, modelType) {
      this.mode = "edit";
      this.currentModelType = modelType;
      if (modelType == 'model') {
        if (!model.fits || model.fits.lenght == 0 || Object.keys(model.fits).length == 0) {
          model.fits = {};
        }
        if (!model.fits.racing) {
          model.fits.racing = {};
          model.fits.sport = {};
          model.fits.roomy = {};
        }
      }
      if (modelType == 'size' && (!model.modelSizes || model.modelSizes.lenght == 0)) {
        model.modelSizes = {};
      }
      this.currentModel = model;
      this.openModal = true;
    },
    closeModal() {
      this.openModal = false;
    },
    getModelSizes(modelName) {
      return this.models
        .filter((item) => item.size && item.modelName == modelName)
        .sort((a, b) => {
          return a.size - b.size;
        });
    },
  },
  created() {
    this.loadData();
    this.$http
      .get("vircos/models")
      .then((response) => {
        const models = response.data.models;
        //map per salvare nel db locale i modelli
        models.map((model) =>
          this.$vlf("vircos-models-base").setItem(
            String(model.idVircosModelsBase),
            model
          )
        );
        this.loadData();
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>

<style lang="scss" scoped></style>
